import { render, staticRenderFns } from "./CollaborateWithSuppliers.vue?vue&type=template&id=51a21b20&scoped=true&"
import script from "./CollaborateWithSuppliers.vue?vue&type=script&lang=js&"
export * from "./CollaborateWithSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./CollaborateWithSuppliers.vue?vue&type=style&index=0&id=51a21b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a21b20",
  null
  
)

export default component.exports